import {Component, Input, numberAttribute} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-standard-form-field',
  imports: [
    NgClass,
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './standard-form-field.component.html',
  styleUrl: './standard-form-field.component.css'
})
export class StandardFormFieldComponent {
  @Input() label!: string; // Label text
  @Input() controlName: string; // Form control name
  @Input() parentForm!: FormGroup; // Parent form group
  @Input() inputId: string;
  @Input() required: boolean = false;
  @Input() type: string = 'text';
  @Input() disabled: boolean = false;
  @Input() maxlength: string;
  @Input() isWidth100 = false;

  getFormControl() {
    return this.parentForm.get(this.controlName);
  }
}
